import { render } from "./ChangeClient.vue?vue&type=template&id=508966b0"
import script from "./ChangeClient.vue?vue&type=script&lang=js"
export * from "./ChangeClient.vue?vue&type=script&lang=js"

import "./ChangeClient.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__